var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-layout',{attrs:{"row":"","align-start":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":""}},[_c('DataCard',{attrs:{"boxDataSet":_vm.boxDataSet}})],1),_c('v-flex',{attrs:{"xs12":"","sm12":""}},[_c('MasterController',{on:{"boxValues":function($event){_vm.boxDataSet = $event}}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }